import mutations from './mutations'
import actions from './actions'
import getters from './getters'
import {get_now_time} from '../../../utils/base'
import {
    NOW_TIME_STATUS_NONE,
    NOW_TIME_STATUS_ONE,
    NOW_TIME_STATUS_TWO,    
    BAT_DETAIL_TIME_ONE,
    BAT_DETAIL_TIME_TWO
} from '../../../const'

const wzWebConfig = window._wzWebConfig_ || {}
let { baseConf } = wzWebConfig

//********************判断当前时间处于哪个时间段*************************
function nowTimeSection(){
    let todayEnd = baseConf.todayEnd
    let todayBegin = baseConf.todayBegin
    let nowTime = get_now_time()
    let todayEndTimes = (new Date(nowTime.years,nowTime.months- 1,nowTime.days,todayEnd.hours,todayEnd.minutes,todayEnd.seconds)).getTime()
    let todayBeginTimes = (new Date(nowTime.years,nowTime.months- 1,nowTime.days,todayBegin.hours,todayBegin.minutes,todayBegin.seconds)).getTime();
    let nowTimeSection
    if(nowTime.times < todayEndTimes){
        nowTimeSection = NOW_TIME_STATUS_NONE
    }else if(nowTime.times >= todayEndTimes && nowTime.times <= todayBeginTimes){
        nowTimeSection = NOW_TIME_STATUS_ONE
    }else if(nowTime.times > todayBeginTimes ){
        nowTimeSection = NOW_TIME_STATUS_TWO
    }
    return nowTimeSection
    
     //console.log(nowTimeSection);
}

//********************判断竞猜详情时间 当前时间处于哪个时间段*************************
function detailTimeStatus(){
    let nowTime = get_now_time()
    let {todayBegin, todayBeginDetail} = baseConf
    let todayDetailBeiginTimes = (new Date(nowTime.years,nowTime.months- 1,nowTime.days,todayBeginDetail.hours,todayBeginDetail.minutes,todayBeginDetail.seconds)).getTime()
    let todayBeginTimes = (new Date(nowTime.years,nowTime.months- 1,nowTime.days,todayBegin.hours,todayBegin.minutes,todayBegin.seconds)).getTime()
    
    let detailTimeStatus
    
    if(nowTime.times >= todayBeginTimes && nowTime.times <= todayDetailBeiginTimes){
        detailTimeStatus = BAT_DETAIL_TIME_TWO
    } else {
        detailTimeStatus = BAT_DETAIL_TIME_ONE
    }
    return detailTimeStatus
     //console.log(nowTimeSection);
}
const state = {
    baseConf            : baseConf || null,
    transdateList       : null,
    shangzheng          : null,
    nowTime             : get_now_time(),
    tomorrow            : null,
    todayIsTransdate    : null,  //判断今天是否是 交易日：0：不是，1：是
    nowTimeSection      : nowTimeSection(),  //初始化时候，当前时间所处的阶段：0 ：0.00-9.15之前 1：9.15-10.00 2：10.00-24.00
    myBetInfo           : null,  //我的下注详情
    nextBetInfo         : null,  //下个交易日的信息
    hasPut              : 0,     //判断个人是否已经押过注了，0：未押过，1：押过
    transDate           : null, 
    detailTimeStatus    : detailTimeStatus(),  //获取详情的时间段状态 1: 15:30-次15:00 2: 15:00-15:30
    summary             : null, //当天的下注信息
    myBetDetail         : null, //我的战绩 下注详情
}
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}